import { render, staticRenderFns } from "./avalonAdminMenu.vue?vue&type=template&id=1b36ab86&scoped=true&"
import script from "./avalonAdminMenu.vue?vue&type=script&lang=js&"
export * from "./avalonAdminMenu.vue?vue&type=script&lang=js&"
import style0 from "./avalonAdminMenu.vue?vue&type=style&index=0&id=1b36ab86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b36ab86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCol,VDivider,VIcon,VRow,VSheet,VSlideXTransition})


/* vuetify-loader */
import installDirectives from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
